import React from 'react';
// @ts-ignore
import styles from './NCZIListPagination.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	hasMoreData: boolean;
	page: number;
	loadData: (page: number) => void;
}

const NCZIListPagination: React.FC<Props> = ({
	page,
	loadData,
	hasMoreData,
}) => {
	return (
		<div className={styles.wrapper}>
			<div>
				{page && page > 1 && (
					<LinkButton
						onClick={() => loadData(page - 1)}
						title={'nczi.paginator.prevnačíst předchozí stranu'}
						theme={Theme.BLUE}
					/>
				)}
			</div>
			<div>
				{hasMoreData && (
					<LinkButton
						onClick={() => loadData((page || 1) + 1)}
						title={'nczi.paginator.next'}
						theme={Theme.BLUE}
					/>
				)}
			</div>
		</div>
	);
};

export default NCZIListPagination;
